import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index'
import CardCalculate from './views/CardCalculate'
import Tariff from './views/Tariff'
import Login from "./views/Login";
import Registration from "./views/Registration";
import OAuth2Result from './views/OAuth2Result'
import Blog from "./views/Blog";
import Article from "./views/Article";
import Cabinet from "./views/Cabinet";
import Profile from "./views/Profile";
import SuperUserList from "./views/SuperUserList";
import AdminArticleList from "./views/AdminArticleList";
import AdminArticleEdit from "./views/AdminArticleEdit";
import AdminPromocode from "./views/AdminPromocode";
import ForgotPassword from "./views/ForgotPassword";
import TermsOfUse from "./views/TermsOfUse";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Error404 from "./views/Error404";
import store from '@/store'
import constants from '@/constants';

Vue.use(Router);

const checkAuthAndRoles = async (to, from, next, roles) => {
    let auth = await store.dispatch('isAuthenticated');

    if (!auth) {
        sessionStorage.setItem(constants.SESSION_STORAGE_REDIRECT, to.path);
        next({name: 'Login'});
        return;
    }

    if (roles && roles.length > 0) {
        const roleCode = store.getters.currentUser.role;
        let access = roles.indexOf(roleCode) != -1;

        if (!access) {
            if (from.params.code === '403')
                next(false)
            else
                next({name: 'Index'});
            return;
        }
    }

    next();
};

const checkNoAuth = async (next) => {
    let auth = await store.dispatch('isAuthenticated');

    if (!!auth) {
        if (store.getters.currentUser.role === 'ROLE_USER')
            next({name: 'Cabinet'});
        else
            next({name: 'Index'});
        return;
    }

    next();
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/calculation',
            name: 'CardCalculate',
            component: CardCalculate
        },
        {
            path: '/tariff',
            name: 'Tariff',
            component: Tariff
        },
        {
            path: '/blog',
            name: 'Blog',
            component: Blog
        },
        {
            path: '/blog/:code',
            name: 'Article',
            component: Article
        },
        {
            path: '/cabinet',
            name: 'Cabinet',
            component: Cabinet,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER'])
            }
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER'])
            }
        },
        {
            path: '/admin/users',
            name: 'SuperUserList',
            component: SuperUserList,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, ['ROLE_SUPER'])
            }
        },
        {
            path: '/admin/articles',
            name: 'AdminArticleList',
            component: AdminArticleList,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, ['ROLE_ADMIN', 'ROLE_SUPER'])
            }
        },
        {
            path: '/admin/articles/:id',
            name: 'AdminArticleEdit',
            component: AdminArticleEdit,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, ['ROLE_ADMIN', 'ROLE_SUPER'])
            }
        },
        {
            path: '/admin/promocode',
            name: 'AdminPromocode',
            component: AdminPromocode,
            beforeEnter: (to, from, next) => {
                checkAuthAndRoles(to, from, next, ['ROLE_ADMIN', 'ROLE_SUPER'])
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: (to, from, next) => {
                checkNoAuth(next);
            }
        },
        {
            path: '/registration',
            name: 'Registration',
            component: Registration,
            beforeEnter: (to, from, next) => {
                checkNoAuth(next);
            }
        },
        {
            path: '/oauth2/result',
            name: 'OAuth2Result',
            component: OAuth2Result,
        },
        {
            path: '/forgot-password',
            name: 'ForgotPassword',
            component: ForgotPassword,
            beforeEnter: (to, from, next) => {
                checkNoAuth(next);
            }
        },
        {
            path: '/terms-of-use',
            name: 'TermsOfUse',
            component: TermsOfUse
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/404',
            component: Error404,
            name: 'Error404'
        },
        // Должно стоять последним
        {
            path: '/*',
            redirect: '/404'
        }
    ]
})
